import styled from 'styled-components';

const ListActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    overflow-x: scroll;
    overflow-y: visible;
    padding: 0 8px;
    position: absolute;
  }
`;

export default ListActionsContainer;
